import { MuiThemeProvider } from '@material-ui/core';
import React, { useEffect } from 'react';
import { theme } from './theme';
import { AiAssistantWrapper } from 'components/AiAssistant';
import { Footer } from 'components/footer';
import { setDDUserData } from 'datadog-rum';
import { useGlobalState } from 'store/reducers/reducer';
import './app.css';
const TestAccountNotice = () => (React.createElement("div", { className: "test-account-banner", role: "status" },
    "This is a Test Account \u2014 verifications use partially simulated results.",
    ' ',
    React.createElement("a", { href: "https://docs.vouched.id/docs/test-accounts", rel: "noopener noreferrer", target: "_blank" }, "Learn more")));
export const AppRoot = ({ children }) => {
    const { state } = useGlobalState();
    const { user, account, accessToken } = state;
    const { id, email, accountId } = user ?? {};
    useEffect(() => {
        if (!id || !accountId) {
            return;
        }
        setDDUserData(id, Number.parseInt(accountId, 10), email);
    }, [id, accountId, email]);
    return (React.createElement(MuiThemeProvider, { theme: theme },
        React.createElement("div", { className: "app" },
            React.createElement(AiAssistantWrapper, { accessToken: accessToken },
                account?.isTest && React.createElement(TestAccountNotice, null),
                children,
                React.createElement(Footer, null)))));
};
